import {
  DashboardContentPlaceholder,
  DashboardCardContent,
  DashboardCardHeader,
  DashboardCard,
} from '@pages/dashboard/components';
import { useTransactionHistoryTable } from '@pages/files-reports/containers';
import { NavHistory } from '@ui/components/icons';
import { useHasPermission } from '@shared/hooks';
import { useTranslation } from 'react-i18next';
import { DataTable } from '@ui/components';
import { Routes } from '@shared/enums';
import { cn } from '@ui/utils';
import React from 'react';

export const DashboardTransactionsHistory = (props: React.ComponentPropsWithoutRef<'div'>) => {
  const { t } = useTranslation();
  const hasPermission = useHasPermission('DASHBOARD_TRANSACTIONS_HISTORY_SEE_ALL', 'READ');
  const { columnsLength, isFetching, isLoading, table, totalItems } = useTransactionHistoryTable({
    pageSize: 10,
  });

  const { className, ...rest } = props;
  return (
    <DashboardCard className={cn('flex flex-col', className)} {...rest}>
      <DashboardCardHeader
        link={{
          label: t('DASHBOARD.TRANSACTIONS.SEE_ALL'),
          href: `../${Routes.FILES_REPORTS}/${Routes.TRANSACTION_HISTORY}`,
        }}
        title={t('DASHBOARD.TRANSACTIONS.TITLE')}
        isLinkVisible={hasPermission}
        icon={<NavHistory />}
        className="mb-4"
      />

      <DashboardCardContent isLoading={isFetching}>
        {!!totalItems ? (
          <DataTable
            className="[&_thead]:bg-transparent"
            columnsLength={columnsLength}
            isLoading={isLoading}
            table={table}
          />
        ) : (
          <DashboardContentPlaceholder
            title={t('DASHBOARD.TRANSACTIONS.PLACEHOLDER_TITLE')}
            icon={<NavHistory />}
          />
        )}
      </DashboardCardContent>
    </DashboardCard>
  );
};
